module.exports = __webpack_public_path__ + "img/campgrounds.4f1dec5c.jpg";